import { useEffect, useState } from 'react';

const HOUR = 1000 * 60 * 60;

export const useNow = (interval: number = HOUR) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => setNow(new Date()), interval);
    return () => clearInterval(intervalId);
  }, [interval]);

  return now;
};
